type TabWithCountProps = {
  label: string
  count: number
}

const TabWithCount = ({ label, count }: TabWithCountProps) => (
  <div className="flex items-center gap-2">
    <span>{label}</span>
    {count > 0 && (
      <span className="flex items-center justify-center bg-yellow-200 font-medium text-base-700 text-xs px-1 py-0.5 rounded">
        {count}
      </span>
    )}
  </div>
)

export default TabWithCount
